module.exports = __webpack_public_path__ + "static/img/RC48V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RC48V_1.png
// module id = 5ceW
// module chunks = 0